import request from '@/utils/request'

// 0401课程列表
export function queryCourseList (data) {
  return request({
    url: '/course/list',
    method: 'post',
    data
  })
}
// 0402获取课程详情
export function queryCourseDetail (data) {
  return request({
    url: '/course/detail',
    method: 'post',
    data
  })
}
// 0406获取分享课程的url
export function courseShare (data) {
  return request({
    url: '/course/share',
    method: 'post',
    data
  })
}

// 0407 获取课程通知列表
export function queryNotifyList (data) {
  return request({
    url: '/course/notify/list',
    method: 'post',
    data
  })
}

// 0408获取课程通知详情
export function queryNotifyDetail (data) {
  return request({
    url: '/course/notify/detail',
    method: 'post',
    data
  })
}

// 0410 课程报名
export function signCourse (data) {
  return request({
    url: '/course/sign',
    method: 'post',
    data
  })
}

// 0412获取分享课程通知url
export function notifyShare (data) {
  return request({
    url: '/course/notify/share',
    method: 'post',
    data
  })
}

// 0418购买课程
export function buyCourse (data) {
  return request({
    url: '/course/buy',
    method: 'post',
    data
  })
}

// 0416 获取评论数和点赞数
export function getCommentAndLikeCount (data) {
  return request({
    url: '/course/commentLike',
    method: 'post',
    data
  })
}

// 0417 获取点赞状态
export function getIsLike (data) {
  return request({
    url: '/course/islike',
    method: 'post',
    data
  })
}

// 0415 点赞
export function updateCourseLike (data) {
  return request({
    url: '/course/like',
    method: 'post',
    data
  })
}

// 0403 获取评论列表
export function getCommentList (data) {
  return request({
    url: '/course/comment/list',
    method: 'post',
    data
  })
}

// 0404 评论课程
export function courseComment (data) {
  return request({
    url: '/course/comment',
    method: 'post',
    data
  })
}
